import { render, staticRenderFns } from "./Component1.vue?vue&type=template&id=60eec909&scoped=true&"
import script from "./Component1.vue?vue&type=script&lang=js&"
export * from "./Component1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eec909",
  null
  
)

export default component.exports